import * as _ from 'lodash';
import {SubmissionError, FormSubmitHandler} from 'redux-form';

export default async function throwSubmissionError(e) {
  if (_.isFunction(e.json)) {
    e = await e.json();
  }
  if (_.isPlainObject(e.reason)) {
    throw new SubmissionError(e.reason);
  } else if (_.isObject(e.errors)) {
    throw new SubmissionError({_error: e.errors[_.keys(e.errors)[0]]});
  } else if (e.error) {
    throw new SubmissionError({_error: e.error});
  }
  throw e;
}

export function wrapSubmitFunction(submit: FormSubmitHandler): FormSubmitHandler {
  return async (...args) => {
    try {
      return await Promise.resolve(submit(...args));
    } catch (e) {
      return throwSubmissionError(e);
    }
  };
}
